export const convertTimeToDays = (firebaseTimestamp) => {
  try {
    // Handle null, undefined, or empty timestamps gracefully
    if (!firebaseTimestamp) {
      return 0; // Return 0 for missing timestamps (will show as "0 days ago")
    }

    let timestamp;
    if (firebaseTimestamp?._seconds || firebaseTimestamp?.seconds) {
      timestamp = new Date(
        (firebaseTimestamp?._seconds || firebaseTimestamp?.seconds) * 1000 +
          (firebaseTimestamp?._nanoseconds ||
            firebaseTimestamp?.nanoseconds) /
            1000000
      );
    } else if (firebaseTimestamp instanceof Date) {
      timestamp = firebaseTimestamp;
    } else {
      // For invalid formats, return 0 instead of logging error (this is expected for some notifications)
      return 0;
    }

    const currentDate = new Date();
    const timeDifference = currentDate - timestamp;
    const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    return daysAgo >= 0 ? daysAgo : 0;
  } catch (error) {
    console.error('Error converting timestamp:', error);
    return 0;
  }
};

export const getRandomPastelColor = (name) => {
  const hash = [...name].reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const hue = hash % 360;
  return `hsl(${hue}, 70%, 80%)`;
};

export const formatName = (name) => {
  return name
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const getAttachmentsDetails = (attachmentId, allAttachments) => {
  console.log('Searching for attachment details for ID:', attachmentId);
  if (!allAttachments) {
    console.error('Attachments list is not available yet.');
    return null;
  }
  return (
    allAttachments?.data?.find(
      (attachment) => attachment.docId === attachmentId
    ) || null
  );
};

export const getNotificationCounts = (notificationsList) => {
  const messages = notificationsList.filter((n) =>
    [
      'patientMessage',
      'doctorMessage',
      'teacherMessage',
      'studentMessage',
      'groupMessage',
    ].includes(n.notificationSource)
  ).length;

  const videos = notificationsList.filter((n) =>
    [
      'patientVideoUploaded',
      'doctorVideoUploaded',
      'teacherVideoUploaded',
      'studentVideoUploaded',
      'uploadVideo', // Generic video upload source
    ].includes(n.notificationSource)
  ).length;

  const attachments = notificationsList.filter((n) =>
    [
      'patientDocumentUploaded',
      'doctorDocumentUploaded',
      'teacherDocumentUploaded',
      'studentDocumentUploaded',
      'patientAttachmentUploaded',
      'doctorAttachmentUploaded',
      'teacherAttachmentUploaded',
      'studentAttachmentUploaded',
    ].includes(n.notificationSource)
  ).length;

  const goals = notificationsList.filter((n) =>
    [
      'patientGoalCreated',
      'doctorGoalCreated',
      'teacherGoalCreated',
      'studentGoalCreated',
    ].includes(n.notificationSource)
  ).length;

  const quicktracks = notificationsList.filter((n) =>
    [
      'patientBehaviorCreated',
      'doctorBehaviorCreated',
      'teacherBehaviorCreated',
      'studentBehaviorCreated',
    ].includes(n.notificationSource)
  ).length;

  const profiles = notificationsList.filter((n) =>
    ['newPatientReg'].includes(n.notificationSource)
  ).length;

  return {
    messages,
    videos,
    attachments,
    goals,
    quicktracks,
    profiles,
    total: notificationsList.length,
  };
}; 